exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-content {\r\n  min-height: 122px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Programing/carbooking/src/app/shared/services/app-loader/app-loader.component.css
// module id = ../../../../../src/app/shared/services/app-loader/app-loader.component.css
// module chunks = main